import { User, Submission, Khatian, AuditLog, ProcessingJob } from '../types'

export const users: Record<string, User> = {
  operator: {
    id: 'u1',
    name: 'Rahim Uddin',
    role: 'operator',
    designation: 'Settlement Press Operator',
  },
  officer: {
    id: 'u2',
    name: 'Karim Chowdhury',
    role: 'officer',
    designation: 'Settlement Press Officer',
  },
  zso: {
    id: 'u3',
    name: 'Abdul Majid',
    role: 'zso',
    designation: 'Zonal Settlement Officer',
  },
  admin: {
    id: 'u4',
    name: 'Syed Hasan',
    role: 'admin',
    designation: 'DLRS Admin Officer',
  },
}

export const mockSubmissions: Submission[] = [
  {
    id: 'SUB-2023-001',
    district: 'Dhaka',
    upazila: 'Savar',
    mouja: 'Aminbazar',
    jlNumber: '45',
    khatianCount: 1250,
    status: 'pending_validation',
    submittedBy: 'Rahim Uddin',
    submittedAt: '2023-10-25T10:30:00Z',
    moujaDetails: [
      {
        district: 'Dhaka',
        upazila: 'Savar',
        mouja: 'Aminbazar',
        jlNumber: '45',
        khatianStartNo: '1',
        khatianEndNo: '1250',
        totalKhatian: '1250',
        totalSheet: '125',
        remarks: 'Initial batch',
      },
    ],
    files: {
      khatianData: 'aminbazar_data.dat',
      gadgetCopy: 'gadget_45.pdf',
      handoverLetter: 'handover_001.pdf',
    },
    isUnicode: false,
  },
  {
    id: 'SUB-2023-002',
    district: 'Gazipur',
    upazila: 'Tongi',
    mouja: 'Ershad Nagar',
    jlNumber: '12',
    khatianCount: 840,
    status: 'processing',
    submittedBy: 'Abdul Majid',
    submittedAt: '2023-10-24T14:15:00Z',
    moujaDetails: [
      {
        district: 'Gazipur',
        upazila: 'Tongi',
        mouja: 'Ershad Nagar',
        jlNumber: '12',
        khatianStartNo: '1001',
        khatianEndNo: '1840',
        totalKhatian: '840',
        totalSheet: '84',
        remarks: '',
      },
    ],
    files: {
      khatianData: 'ershad_unicode.csv',
      gadgetCopy: 'gadget_12.pdf',
      handoverLetter: 'handover_002.pdf',
    },
    isUnicode: true,
  },
  {
    id: 'SUB-2023-003',
    district: 'Narayanganj',
    upazila: 'Rupganj',
    mouja: 'Bhulta',
    jlNumber: '88',
    khatianCount: 2100,
    status: 'ready_for_approval',
    submittedBy: 'Rahim Uddin',
    submittedAt: '2023-10-23T09:45:00Z',
    moujaDetails: [
      {
        district: 'Narayanganj',
        upazila: 'Rupganj',
        mouja: 'Bhulta',
        jlNumber: '88',
        khatianStartNo: '1',
        khatianEndNo: '2100',
        totalKhatian: '2100',
        totalSheet: '210',
        remarks: '',
      },
    ],
    files: {
      khatianData: 'bhulta_data.dat',
      gadgetCopy: 'gadget_88.pdf',
      handoverLetter: 'handover_003.pdf',
    },
    isUnicode: false,
  },
  {
    id: 'SUB-2023-004',
    district: 'Sylhet',
    upazila: 'Golapganj',
    mouja: 'Dhaka Dakkhin',
    jlNumber: '105',
    khatianCount: 450,
    status: 'rejected',
    submittedBy: 'Rahim Uddin',
    submittedAt: '2023-10-22T11:20:00Z',
    moujaDetails: [
      {
        district: 'Sylhet',
        upazila: 'Golapganj',
        mouja: 'Dhaka Dakkhin',
        jlNumber: '105',
        khatianStartNo: '501',
        khatianEndNo: '950',
        totalKhatian: '450',
        totalSheet: '45',
        remarks: '',
      },
    ],
    files: {
      khatianData: 'dhaka_dakkhin.dat',
      gadgetCopy: 'gadget_105.pdf',
      handoverLetter: 'handover_004.pdf',
    },
    isUnicode: false,
    remarks: 'Gadget copy is illegible. Please re-scan and upload.',
  },
  {
    id: 'SUB-2023-005',
    district: 'Chittagong',
    upazila: 'Hathazari',
    mouja: 'Fatehabad',
    jlNumber: '34',
    khatianCount: 3200,
    status: 'published',
    submittedBy: 'Abdul Majid',
    submittedAt: '2023-10-20T16:00:00Z',
    moujaDetails: [
      {
        district: 'Chittagong',
        upazila: 'Hathazari',
        mouja: 'Fatehabad',
        jlNumber: '34',
        khatianStartNo: '1',
        khatianEndNo: '3200',
        totalKhatian: '3200',
        totalSheet: '320',
        remarks: '',
      },
    ],
    files: {
      khatianData: 'fatehabad.csv',
      gadgetCopy: 'gadget_34.pdf',
      handoverLetter: 'handover_005.pdf',
    },
    isUnicode: true,
  },
]

export const mockKhatians: Khatian[] = [
  {
    id: 'K-1001',
    khatianNo: '101',
    division: 'Chittagong',
    mouja: 'Fatehabad',
    jlNo: '34',
    district: 'Chittagong',
    upazila: 'Hathazari',
    ownerName: 'Md. Shafiqul Islam',
    fatherName: 'Late Rafiqul Islam',
    area: '0.45 Acres',
    status: 'published',
    publishedDate: '2023-10-21',
  },
  {
    id: 'K-1002',
    khatianNo: '102',
    division: 'Chittagong',
    mouja: 'Fatehabad',
    jlNo: '34',
    district: 'Chittagong',
    upazila: 'Hathazari',
    ownerName: 'Kamal Hossain',
    fatherName: 'Jamal Hossain',
    area: '1.20 Acres',
    status: 'published',
    publishedDate: '2023-10-21',
  },
  {
    id: 'K-1003',
    khatianNo: '103',
    division: 'Chittagong',
    mouja: 'Fatehabad',
    jlNo: '34',
    district: 'Chittagong',
    upazila: 'Hathazari',
    ownerName: 'Nasima Begum',
    fatherName: 'Abdul Karim',
    area: '0.15 Acres',
    status: 'published',
    publishedDate: '2023-10-21',
  },
  {
    id: 'K-1004',
    khatianNo: '45',
    division: 'Dhaka',
    mouja: 'Bhulta',
    jlNo: '88',
    district: 'Narayanganj',
    upazila: 'Rupganj',
    ownerName: 'Jalal Uddin',
    fatherName: 'Siraj Uddin',
    area: '2.50 Acres',
    status: 'ready_for_approval',
  },
  {
    id: 'K-1005',
    khatianNo: '46',
    division: 'Dhaka',
    mouja: 'Bhulta',
    jlNo: '88',
    district: 'Narayanganj',
    upazila: 'Rupganj',
    ownerName: 'Rahima Khatun',
    fatherName: 'Abdur Rahman',
    area: '0.80 Acres',
    status: 'ready_for_approval',
  },
]

export const mockLogs: AuditLog[] = [
  {
    id: 'L-001',
    timestamp: '2023-10-25T10:30:00Z',
    user: 'Rahim Uddin',
    role: 'operator',
    action: 'Upload Data',
    item: 'SUB-2023-001',
    statusChange: 'Draft → Pending Validation',
    details: 'Uploaded 1250 khatians for Aminbazar mouja.',
  },
  {
    id: 'L-002',
    timestamp: '2023-10-24T15:00:00Z',
    user: 'Karim Chowdhury',
    role: 'officer',
    action: 'Validate Data',
    item: 'SUB-2023-002',
    statusChange: 'Pending Validation → Processing',
    details: 'Approved files and forwarded to middleware.',
  },
  {
    id: 'L-003',
    timestamp: '2023-10-24T15:05:00Z',
    user: 'System',
    role: 'admin',
    action: 'Middleware Process',
    item: 'SUB-2023-002',
    details: 'Started Bijoy to Unicode conversion.',
  },
  {
    id: 'L-004',
    timestamp: '2023-10-23T11:00:00Z',
    user: 'System',
    role: 'admin',
    action: 'Middleware Process',
    item: 'SUB-2023-003',
    statusChange: 'Processing → Ready for Approval',
    details: 'Data sanitization and cross-check completed successfully.',
  },
  {
    id: 'L-005',
    timestamp: '2023-10-22T14:30:00Z',
    user: 'Karim Chowdhury',
    role: 'officer',
    action: 'Reject Data',
    item: 'SUB-2023-004',
    statusChange: 'Pending Validation → Rejected',
    details: 'Rejected due to illegible gadget copy.',
  },
  {
    id: 'L-006',
    timestamp: '2023-10-21T10:00:00Z',
    user: 'Syed Hasan',
    role: 'admin',
    action: 'Approve & Publish',
    item: 'SUB-2023-005',
    statusChange: 'Ready for Approval → Published',
    details: 'Final approval given. Pushed 3200 khatians to DLMS.',
  },
]

export const mockJobs: ProcessingJob[] = [
  {
    id: 'JOB-9921',
    submissionId: 'SUB-2023-002',
    mouja: 'Ershad Nagar',
    status: 'processing',
    step: 'Data Sanitization',
    progress: 45,
    startedAt: '2023-10-24T15:05:00Z',
    logs: [
      '[INFO] Started processing job',
      '[INFO] File format verified',
      '[INFO] Extracting records...',
      '[INFO] Sanitizing special characters (45% complete)',
    ],
  },
  {
    id: 'JOB-9920',
    submissionId: 'SUB-2023-003',
    mouja: 'Bhulta',
    status: 'completed',
    step: 'Cross-check',
    progress: 100,
    startedAt: '2023-10-23T10:00:00Z',
    logs: [
      '[INFO] Started processing job',
      '[INFO] Conversion to Unicode successful',
      '[INFO] Mapped 2100 records to DLRS schema',
      '[INFO] Cross-check completed. No errors found.',
      '[SUCCESS] Job finished.',
    ],
  },
  {
    id: 'JOB-9919',
    submissionId: 'SUB-2023-006',
    mouja: 'Dhamrai',
    status: 'error',
    step: 'Unicode Conversion',
    progress: 12,
    startedAt: '2023-10-22T09:00:00Z',
    logs: [
      '[INFO] Started processing job',
      '[INFO] Reading non-unicode file',
      '[ERROR] Invalid byte sequence at line 452. Conversion aborted.',
    ],
  },
]
